const styles = {
  connected: {
    color: '#93B696',
    background: '#E0F5E2',
    padding: '4px 16px',
    borderRadius: '10px',
    maxWidth: 'max-content',
    fontWeight: 800,
  },
  disconnected: {
    color: '#b69393',
    background: '#f5e0e7',
    padding: '4px 16px',
    borderRadius: '10px',
    maxWidth: 'max-content',
    fontWeight: 800,
  },
}

export default styles
